import GeneralUtility from '../../utilities/general-utility';
import PluginAction from '../plugin-action';

/**
 * Action for comparing checklists.
 *
 * @author Reinhard Führicht <rf@typoheads.at>
 */
export default class CompareAction extends PluginAction {
    constructor(container: HTMLElement) {
        super(container);
        const settingsForm = this.container.querySelector<HTMLFormElement>('#settings');
        const compareForm = this.container.querySelector<HTMLFormElement>('#compare');

        if (compareForm) {
            // Reload page, when the selected checklist change
            compareForm.querySelectorAll<HTMLInputElement>('select.form-select').forEach((select: HTMLInputElement) => {
                select.addEventListener('change', () => {
                    compareForm.submit();
                });
            });
        }

        if (settingsForm) {
            // Remember the selected season as a parameter in the URL
            settingsForm.querySelectorAll<HTMLLinkElement>('[data-season]').forEach(button => {
                button.addEventListener('click', () => {
                    if (button.dataset.season) {
                        GeneralUtility.addUrlParameter('season', button.dataset.season, true);
                    }
                });
            });

            // Initialize hiding/showing certain sections from the print view
            settingsForm.querySelectorAll<HTMLInputElement>('.form-check-input').forEach((checkbox: HTMLInputElement) => {
                checkbox.addEventListener('change', () => {
                    this.toggleVisibility(checkbox);
                });
                this.toggleVisibility(checkbox);
            });
        }

        CompareAction.emitter.emit('ready', this);
    }

    /**
     * Hides or shows specific sections in the compare view.
     *
     * @param {HTMLInputElement} checkbox
     */
    private toggleVisibility(checkbox: HTMLInputElement): void {
        const id = checkbox.id;
        let elements: NodeListOf<Element> | null = null;
        if (id === 'show-notes') {
            elements = this.container.querySelectorAll<HTMLElement>('*[data-row-type="notes"]');
        }

        if (elements) {
            if (checkbox.checked) {
                elements.forEach(element => {
                    element.classList.remove('d-none');
                });
            } else {
                elements.forEach(element => {
                    element.classList.add('d-none');
                });
            }
        }
    }
}
